import { useMutation } from '@tanstack/react-query';

import { download } from '../request';

export const useDownloadDocument = () => {
  return useMutation({
    mutationFn: (id: number) => {
      return download(`/documents/${id}`, { method: 'GET' });
    },
  });
};
